import api from "./api";

// Capa de servicios API del dominio "mensajes individuales programados"
// (scheduled-individual-messages) (FSD / capa API transversal).
// Wrappers de transporte finos: la construcción de payloads/params vive en el
// componente; aquí solo se centraliza el endpoint (un único lugar que tocar si cambia).

export const listScheduledMessages = (params) =>
  api.get("/scheduled-individual-messages", { params });
export const listScheduledMessagesByContact = (contactId) =>
  api.get(`/scheduled-individual-messages/contact/${contactId}`);
export const createScheduledMessage = (payload) =>
  api.post("/scheduled-individual-messages", payload);
export const updateScheduledMessage = (scheduledMessageId, payload) =>
  api.put(`/scheduled-individual-messages/${scheduledMessageId}`, payload);
export const deleteScheduledMessage = (scheduledMessageId) =>
  api.delete(`/scheduled-individual-messages/${scheduledMessageId}`);
